import { animate, query, stagger, style, transition, trigger } from '@angular/animations';

const queryEnter = query(
  ':enter',
  [
    style({ opacity: 0, transform: 'translateY(-100%) scaleX(0)' }),
    stagger(50, [
      animate('375ms', style({ transform: 'translateY(0%) scaleX(1.1)' })),
      animate('125ms ease-in-out', style({ opacity: 1, transform: 'translateY(0%) scaleX(1)' })),
    ]),
  ],
  {
    optional: true,
  },
);

export const comeInAnimation = trigger('comeIn', [
  transition('false => true', [queryEnter]),
  transition('void => *', [queryEnter]),
]);
